import React, { lazy, Suspense } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import MaterialSwitch from "../../MaterialComponents/MaterialSwitch";
//5889
import { TextField } from "formik-mui";
//5888
import { Field, useFormikContext } from "formik";
import CallToActionCheckBox from "../../MaterialComponents/CallToActionCheckbox";
import BrandAutoComplete from "../../MaterialComponents/BrandAutoComplete";
import MoreInfo from "../../MaterialComponents/MoreInfo";
import MoreInfoPictureContent from "../../MaterialComponents/MoreInfoPictureContent";
// import { FacebookPost } from "@lumen-developer/lumen-lookalikes/dist/Previews";
import Divider from "@mui/material/Divider";
import validator from "validator";
import propTypes from "prop-types";


export default function FacebookStandard({ brandTypes }) {
  const { values } = useFormikContext();

  function FacebookStandardValidationSchema(value, name) {
    let error;
    if (name === "stim_url") {
      if (!value) {
        error = "Required";
      } else if (!validator.isURL(value)) {
        error = "Must be a valid URL";
      } else if (value.length > 512) {
        error = "Too long";
      }
    }
    if (name === "fb_channel_name") {
      if (!value) {
        error = "Required";
      } else if (value.length > 50) {
        error = "Too long";
      }
    }
    if (name === "fb_profile_src") {
      if (!value) {
        error = "Required";
      } else if (!validator.isURL(value)) {
        error = "Must be a valid URL";
      } else if (value.length > 511) {
        error = "Too long";
      }
    }
    if (name === "fb_description") {
      if (!value) {
        error = "Required";
      } else if (value.length > 511) {
        error = "Too long";
      }
    }
    if (values.promoted) {
      if (name === "fb_promoted_description") {
        if (!value) {
          error = "Required";
        } else if (value.length > 26) {
          error = "Too long";
        }
      }
      if (name === "fb_promoted_description2") {
        if (!value) {
          error = "Required";
        }
      }
    }
    if (name === "fb_promoted_domain") {
      if (!value) {
        error = "Required";
      } else if (!validator.isURL(value)) {
        error = "Must be a valid URL";
      } else if (value.length > 50) {
        error = "Too long";
      }
    }
    return error;
  }

  return (
    <>
      <Divider variant="middle" />

      <Grid
        style={{ margin: "24px 0px 12px" }}
        container
        wrap="nowrap"
        justifyContent="center"
        item
        xs={12}
      >
        <Typography align="center" variant="h6" component={"span"}>
          Facebook news feed
        </Typography>
        <MoreInfo
          widePaper
          outerContainerClassName="moreInfo"
          popup={
            <MoreInfoPictureContent
              standardDescription="This ad will appear as the third post within a facebook news feed"
              illustration="faceBookStandard"
            />
          }
        />
      </Grid>

      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          padding: 16,
          }}
          >
            
        <div style={{ flex: 1, padding: 16, display: "flex" }}>
          {/* <FacebookPost
            lang_code={values.language.code.toUpperCase()}
            fb_profile_src={values.fb_profile_src}
            fb_channel_name={values.fb_channel_name}
            fb_description={values.fb_description}
            fb_promoted_domain={values.fb_promoted_domain}
            fb_promoted_description={values.fb_promoted_description}
            fb_promoted_button_text={values.fb_promoted_button_text}
            stim_url={values.stim_url}
          /> */}

        </div>
        <div
          style={{
           flex: 1,
           overflowY: "auto",
           padding: 16,
           display: "flex",
          }}
        >
          <Grid style={{ width: "100%" }} container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" component={"span"}>
                Please enter the ad URL and choose the brand name
              </Typography>
            </Grid>

            <Grid container wrap="nowrap" item xs={12}>
              <Field
                fullWidth
                name="stim_url"
                component={TextField}
                label="Ad URL"
                variant="filled"
                validate={(value) =>
                  FacebookStandardValidationSchema(value, "stim_url")
                }
              />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="A link to a webpage only featuring the test ad"
              />
            </Grid>

            <Grid container wrap="nowrap" item xs={12}>
              <BrandAutoComplete brandTypes={brandTypes} />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="The brand name of the company featured in the test ad "
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle1" component={"span"}>
                Now customize the post
              </Typography>
            </Grid>

            <Grid container wrap="nowrap" item xs={12}>
              <Field
                fullWidth
                name="fb_profile_src"
                component={TextField}
                label="Profile photo URL"
                variant="filled"
                validate={(value) =>
                  FacebookStandardValidationSchema(value, "fb_profile_src")
                }
              />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="A link to a webpage only featuring the profile photo"
              />
            </Grid>

            <Grid container wrap="nowrap" item xs={12}>
              <Field
                fullWidth
                name="fb_channel_name"
                component={TextField}
                label="Profile name"
                variant="filled"
                validate={(value) =>
                  FacebookStandardValidationSchema(value, "fb_channel_name")
                }
              />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="The profile name as you would like it to appear"
              />
            </Grid>
            <Grid container wrap="nowrap" item xs={12}>
              <Field
                fullWidth
                name="fb_description"
                component={TextField}
                label="Description"
                multiline
                variant="filled"
                validate={(value) =>
                  FacebookStandardValidationSchema(value, "fb_description")
                }
              />
              <MoreInfo
                outerContainerClassName="moreInfo"
                popup="The text appearing above the image or video"
              />
            </Grid>

            {values.stim_url.split(".")[
              values.stim_url.split(".").length - 1
            ] === "mp4" ? (
              <Grid container wrap="nowrap" item xs={12}>
                <Grid item xs={12}>
                  <MaterialSwitch
                    label="Play sound automatically?"
                    name="has_sound"
                  />
                </Grid>
                <MoreInfo
                  outerContainerClassName="moreInfo"
                  popup="This will start sound playing as soon as the video starts"
                />
              </Grid>
            ) : (
              ""
            )}
            {values.promoted ? (
              <>
                <Grid container wrap="nowrap" item xs={12}>
                  <Field
                    fullWidth
                    name="fb_promoted_domain"
                    component={TextField}
                    label="Domain name"
                    variant="filled"
                    validate={(value) =>
                      FacebookStandardValidationSchema(
                        value,
                        "fb_promoted_domain"
                      )
                    }
                  />
                  <MoreInfo
                    outerContainerClassName="moreInfo"
                    popup={`Domain name of the brand's website`}
                  />
                </Grid>
                <Grid container wrap="nowrap" item xs={12}>
                  <Field
                    fullWidth
                    name="fb_promoted_description"
                    component={TextField}
                    label="Headline"
                    variant="filled"
                    validate={(value) =>
                      FacebookStandardValidationSchema(
                        value,
                        "fb_promoted_description"
                      )
                    }
                  />
                  <MoreInfo
                    outerContainerClassName="moreInfo"
                    popup={`The ad's key message`}
                  />
                </Grid>
                <Grid container wrap="nowrap" item xs={12}>
                  <Field
                    fullWidth
                    name="fb_promoted_description2"
                    component={TextField}
                    label="Subheading"
                    variant="filled"
                    validate={(value) =>
                      FacebookStandardValidationSchema(
                        value,
                        "fb_promoted_description2"
                      )
                    }
                  />
                  <MoreInfo
                    outerContainerClassName="moreInfo"
                    popup="Clear description of the product advertised"
                  />
                </Grid>
                <Grid container wrap="nowrap" item xs={12}>
                  <CallToActionCheckBox name="fb_promoted_button_text" />
                  <MoreInfo
                    outerContainerClassName="alignToTop"
                    popup="Text in the main call to action button"
                  />
                </Grid>
              </>
            ) : (
              <div style={{ height: 350 }} />
            )}
          </Grid>
        </div>
      </div>
      <Grid item xs={12}>
        <Divider variant="middle" />
      </Grid>
    </>
  );
}

FacebookStandard.propTypes = {
  brandTypes: propTypes.object,
};
